import React from 'react'

// Styles //
import "./categoryTag.scss";

interface CategoryTagProps {
    label: string;
    active: string;
    onActive?: () => void;
}

const CategoryTag = ({ label, active, onActive }: CategoryTagProps) => {
    return (
        <button className={`a-category-tag ${label === active ? "active" : ""}`} onClick={onActive}>{label}</button>
    )
}

export default CategoryTag